/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ListingInputs */

const en_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Listing`)
};

const es_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo anuncio`)
};

const fr_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle annonce`)
};

const de_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Inserat`)
};

const ja_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新規出品`)
};

const zh_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新建商品`)
};

const ar_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلان جديد`)
};

const id_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Baru`)
};

const it_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo Annuncio`)
};

const ru_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое объявление`)
};

const pt_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo Anúncio`)
};

const ko_new_listing = /** @type {(inputs: New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 상품`)
};

/**
* | output |
* | --- |
* | "New Listing" |
*
* @param {New_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const new_listing = /** @type {((inputs?: New_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_listing(inputs)
	if (locale === "es") return es_new_listing(inputs)
	if (locale === "fr") return fr_new_listing(inputs)
	if (locale === "de") return de_new_listing(inputs)
	if (locale === "ja") return ja_new_listing(inputs)
	if (locale === "zh") return zh_new_listing(inputs)
	if (locale === "ar") return ar_new_listing(inputs)
	if (locale === "id") return id_new_listing(inputs)
	if (locale === "it") return it_new_listing(inputs)
	if (locale === "ru") return ru_new_listing(inputs)
	if (locale === "pt") return pt_new_listing(inputs)
	return ko_new_listing(inputs)
});